
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Tournament </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2019 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Fide Chess <span>Competition 2019</span></h2>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>BLITZ RESULT</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/otJ4k" target="_blank"> Round 1 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/gvdF7" target="_blank">Round 2 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/L7s4R" target="_blank">Round 3 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/6ypga" target="_blank">Round 4 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/Jw2dV" target="_blank">Round 5 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/9YWGG" target="_blank">Round 6 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/d6fn9" target="_blank">Round 7</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/byo4Z" target="_blank">Round 8</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/iynqY" target="_blank">Round 9</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/rosJG" target="_blank">Round 10</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/VPqG1" target="_blank">Round 11</a> </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>CHESS RESULT</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/JfVah" target="_blank">Round 1 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/5UcUZ" target="_blank">Round 2 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/rvE9e" target="_blank">Round 3 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/V7YH8" target="_blank">Round 4 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/ZJCsV" target="_blank">Round 5 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/cySv3" target="_blank">Round 6 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/s7W2Q" target="_blank">Round 7</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/zRpzF" target="_blank">Round 8</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/XSgtJ" target="_blank">Round 9</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/Hf8kr" target="_blank">Round 10</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/A9NyW" target="_blank">Round 11</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/wfA9U" target="_blank">Round 12</a> </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>RAPID RESULT</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/J4n8z" target="_blank">Round 1 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/SUkJa" target="_blank">Round 2 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/okzFz" target="_blank">Round 3 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/9X2Bu" target="_blank">Round 4 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/T3PxF" target="_blank">Round 5 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/irWLJ" target="_blank">Round 6 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/rtKz6" target="_blank">Round 7 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/mMLZk" target="_blank">Round 8 </a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/CDYQP" target="_blank">Round 9</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/F7rBC" target="_blank">Round 10</a> </h4>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/79uSk" target="_blank">Round 11</a> </h4>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>MEDIA COVERAGE</h4>
                    </div>
                </div>
                <div class="col-md-4 text-end">
                    <a href="media#media_fidechess"    class="btn button--effect-1"><span>
                    View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <div class="category-icon-title shadow-inset">

                        <div class="category-title">
                            <span class="flaticon-pdf"></span>
                            <h4><a href="https://urlzs.com/vS9uF" target="_blank">FIDE Press Coverage 2019 </a> </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
